webpackJsonp([8],{

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(266);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("fd3eb756", content, true);

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ForgetPassword.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leancloud_storage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leancloud_storage__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      submitted: false
    };
  },

  validators: {
    email: {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__["Validator"].value(v).required('邮箱必填').email('请输入有效的邮箱地址');
      }
    }
  },
  methods: {
    forget: function forget() {
      var _this = this;

      this.submitted = true;
      this.$validate().then(function (isSuccess) {
        if (isSuccess) {
          __WEBPACK_IMPORTED_MODULE_1_leancloud_storage___default.a.User.requestPasswordReset(_this.email).then(function () {
            _this.$toast('请打开邮箱查看重置密码邮件');
            _this.$router.go(-1);
          }).catch(function (error) {
            _this.$toast(err.message || '未知错误');
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": ""
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('div', {
    staticClass: "scrollable container flex-1 flex flex-row"
  }, [_c('form', {
    staticClass: "flex-1",
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.forget($event)
      }
    }
  }, [_c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "请输入您的邮箱",
      "autofocus": "",
      "tabindex": "1"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [(_vm.submitted && _vm.validation.hasError('email')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('email')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("重置密码")])], 1), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("如果您没有绑定邮箱，请联系管理员来重置密码")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(268),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6be5eab4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/8.7791c263fb339a662e64.js